<template>
  <el-form
    ref="form"
    :model="form"
    :rules="rules"
    label-position="top"
    @submit.native.prevent="handleSubmit"
  >
    <el-card>
      <el-form-item label="ชื่อผู้ใช้งาน" prop="username">
        <el-input v-model="form.username"></el-input>
      </el-form-item>
      <el-form-item label="รหัสผ่าน" prop="password">
        <el-input v-model="form.password" show-password></el-input>
      </el-form-item>
    </el-card>
    <el-form-item>
      <el-button
        type="primary"
        :class="$style.loginButton"
        native-type="submit"
      >
        เข้าสู่ระบบ
      </el-button>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  data() {
    return {
      form: {
        username: '',
        password: ''
      },
      rules: {
        username: [
          { required: true, message: 'กรุณากรอกชื่อผู้ใช้งาน', trigger: 'blur' }
        ],
        password: [
          { required: true, message: 'กรุณากรอกรหัสผ่าน', trigger: 'blur' }
        ]
      }
    }
  },

  methods: {
    handleSubmit() {
      this.$refs.form.validate().then(() => {
        this.$emit('submit', this.form)
      })
    },

    reset() {
      this.$refs.form.resetFields()
    }
  }
}
</script>

<style lang="scss" module>
.loginButton {
  display: block;
  width: 100%;
  max-width: 270px;
  margin: 2.5rem auto 0;
  font-size: 1.125rem;
  font-weight: bold;
  line-height: 1em;
  background-color: #ffffff !important;
  color: #d9251d !important;
  box-shadow: 0 0.125rem #10451b;
  min-height: 3.75rem;
  border-color: #ffffff !important;
}
</style>
